/* Primaccino V0.4 gallery: only selects artwork already vetted in Shopify admin. */
(() => {
  const KEY = 'primaccino:selected-artwork:v1';
  const studioSelector = '[data-binder-studio]';
  function isImageAllowed(raw) {
    try {
      const url = new URL(raw, location.origin);
      return url.protocol === 'https:' || (url.origin === location.origin && url.protocol === 'http:')
        ? (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.net'))
        : false;
    } catch { return false; }
  }
  function init(root) {
    if (root.dataset.galleryInit === 'yes') return;
    root.dataset.galleryInit = 'yes';
    const cards = [...root.querySelectorAll('[data-gallery-card]')];
    if (!cards.length) return;
    const search = root.querySelector('[data-gallery-search]');
    const category = root.querySelector('[data-gallery-category]');
    const toolbar = root.querySelector('[data-gallery-toolbar]');
    const count = root.querySelector('[data-gallery-count]');
    const empty = root.querySelector('[data-gallery-no-results]');
    const dialog = root.querySelector('[data-gallery-dialog]');
    let activeCard = cards[0];
    toolbar.hidden = false;
    const categories = [...new Set(cards.map(card => card.dataset.category).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'fr'));
    for (const name of categories) {
      const option=document.createElement('option');option.value=name;option.textContent=name;category.append(option);
    }
    function filter() {
      const q=search.value.trim().toLocaleLowerCase('fr');
      let visible=0;
      cards.forEach(card=>{
        const match=(!q || `${card.dataset.title} ${card.dataset.category}`.toLocaleLowerCase('fr').includes(q)) && (!category.value || card.dataset.category === category.value);
        card.hidden=!match;
        if(match) visible++;
      });
      count.textContent=`${visible} création${visible!==1?'s':''}`;
      if(empty) empty.hidden=visible>0;
    }
    let searchTimer;search.addEventListener('input',()=>{clearTimeout(searchTimer);searchTimer=setTimeout(filter,130);});category.addEventListener('change',filter);root.querySelector('[data-gallery-reset]')?.addEventListener('click',()=>{search.value='';category.value='';filter();search.focus();});filter();
    function getSelection(card) {
      const image=new URL(card.dataset.image,location.origin).href;
      if (!isImageAllowed(image)) return null;
      return {id:card.dataset.id.slice(0,128),title:card.dataset.title.slice(0,150),category:card.dataset.category.slice(0,80),estimatedHours:Number(card.dataset.hours)||2,image};
    }
    function select(card) {
      const selected = getSelection(card);
      if (!selected) {alert('L’illustration n’est pas disponible.');return;}
      try { sessionStorage.setItem(KEY,JSON.stringify(selected)); } catch {alert('Impossible d’enregistrer le choix dans ce navigateur.');return;}
      dialog?.close();
      const studio=document.querySelector(studioSelector);
      if(studio){window.dispatchEvent(new CustomEvent('primaccino:artwork-selected',{detail:selected}));studio.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
      else window.location.assign(root.dataset.studioLink || '/#studio');
    }
    cards.forEach(card => {
      card.querySelector('[data-gallery-pick]')?.addEventListener('click',()=>select(card));
      card.querySelector('[data-gallery-view]')?.addEventListener('click',()=>{
        activeCard=card;
        const img=dialog.querySelector('[data-gallery-modal-image]');
        img.src=card.dataset.image;img.alt=card.dataset.title;
        dialog.querySelector('[data-gallery-modal-title]').textContent=card.dataset.title;
        dialog.querySelector('[data-gallery-modal-category]').textContent=card.dataset.category;
        dialog.querySelector('[data-gallery-modal-hours]').textContent=`Peinture : environ ${card.dataset.hours} h (à confirmer par l’artiste)`;
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-gallery-modal-pick]').addEventListener('click',()=>select(activeCard));
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  }
  function boot(scope=document){if(scope.matches?.('[data-pc-gallery]'))init(scope);scope.querySelectorAll?.('[data-pc-gallery]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
